import { Instagram, Phone, MessageCircle } from "lucide-react";
import { BRAND, CREDIT, INSTAGRAM, LOGO, NAV_LINKS, PHONE, PHONE_DISPLAY, WA_URL } from "./data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[color:var(--ink)] text-[color:var(--paper)]"
    >
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-14 pb-8">
        <div className="grid grid-cols-12 gap-8 lg:gap-12">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-4">
              <span className="inline-block h-14 w-14 rounded-full overflow-hidden ring-1 ring-[color:var(--line-inv)] bg-[color:var(--paper-2)]">
                <img src={LOGO} alt="Hashtag Sakleshpura Homestay logo" className="h-full w-full object-cover" />
              </span>
              <div>
                <div className="font-display text-[1.7rem] leading-none">
                  {BRAND.name}
                  <span className="font-display-italic text-[color:var(--clay)]">.</span>
                </div>
                <div className="font-mono-alt text-[color:var(--paper)]/60 mt-2">
                  {BRAND.tagline}
                </div>
              </div>
            </div>

            <p className="mt-6 max-w-md font-display text-[1.2rem] leading-[1.4]">
              A coffee-estate homestay in the Western Ghats. Come slow, leave slower.
            </p>

            <div
              data-testid="footer-owner"
              className="mt-6 max-w-md rounded-2xl border border-[color:var(--line-inv)] bg-[color:var(--paper)]/5 px-5 py-4 flex items-start gap-4"
            >
              {/* Owner portrait —
                  REPLACE this src with an actual portrait photo of
                  Mr Megharaj R. For now it falls back to a monogram tile. */}
              <div
                data-testid="owner-portrait"
                aria-label="Portrait of Mr Megharaj R, proprietor"
                className="flex-shrink-0 h-14 w-14 rounded-full ring-2 ring-[color:var(--sand)]/70 bg-[color:var(--forest)] flex items-center justify-center overflow-hidden"
                style={{
                  boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                }}
              >
                <span
                  aria-hidden="true"
                  className="font-display text-[1.5rem] text-[color:var(--sand)] leading-none"
                >
                  M
                </span>
              </div>

              <div className="min-w-0">
                <div className="font-mono-alt text-[color:var(--sand)]">
                  Proprietor · Est. 2019
                </div>
                <div className="mt-1.5 font-display text-[1.3rem] leading-tight text-[color:var(--paper)]">
                  Mr Megharaj&nbsp;R
                </div>
                <p className="mt-2 text-[0.9rem] text-[color:var(--paper)]/75 leading-relaxed">
                  Second-generation coffee planter and your host at the estate —
                  welcoming guests to Sakleshpura for over 6.5 years.
                </p>
              </div>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="font-mono-alt text-[color:var(--paper)]/50 mb-4">Navigate</div>
            <ul className="flex flex-col gap-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover-underline font-display text-[1.05rem]">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <div className="font-mono-alt text-[color:var(--paper)]/50 mb-4">Reach us</div>
            <ul className="flex flex-col gap-3">
              <li>
                <a href={`tel:+${PHONE}`} className="flex items-center gap-3 hover:text-[color:var(--sand)] transition-colors">
                  <Phone size={16} /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[color:var(--sand)] transition-colors">
                  <MessageCircle size={16} /> WhatsApp
                </a>
              </li>
              <li>
                <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[color:var(--sand)] transition-colors">
                  <Instagram size={16} /> @hashtag_sakleshpura
                </a>
              </li>
              <li className="text-[color:var(--paper)]/70 pt-1 max-w-xs">
                Hiridanahalli, Sakleshpura,<br />Karnataka 573123, India
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[color:var(--line-inv)] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[color:var(--paper)]/60 font-mono-alt">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Hashtag Sakleshpura Homestay. All rights reserved.
          </span>
          <span>
            Made by{" "}
            <a
              data-testid="footer-credit"
              href={CREDIT.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[color:var(--sand)] hover-underline"
            >
              {CREDIT.by}
            </a>
            {" "}· All rights reserved
          </span>
        </div>
      </div>
    </footer>
  );
}
